import * as React from 'react'
import styled, { css } from 'styled-components'
import { ColorName, Colors } from '../constants'

const IndicatorSpan = styled.span`
  ${(props: { color: ColorName }) => css`
    font-family: arial;
    color: ${Colors[props.color]};
  `};
`

/**
 * Renders ● with given color
 */
export default function Indicator(props: { color: ColorName }) {
  return <IndicatorSpan color={props.color}>&#9679;</IndicatorSpan>
}
